import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import AppBarUI from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { useStores } from './core/src/stores';
import { observer } from 'mobx-react';
import ProfileButton from './core/src/components/common/ProfileButton';
import Image from './core/src/components/common/Image';
import appStyles from './config/appStyles';
import { Link as RLink } from 'react-router-dom';
import { detectAlpha2Country } from './utils/country';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => appStyles.appBar(theme, drawerWidth));

const Logo = () => {
  const classes = useStyles();
  const { userStore } = useStores();
  const { isLogged } = userStore;

  if (isLogged) {
    return (
      <RLink className={classes.linkMui} to="/myarea">
        <Image className={classes.logo} name="logo" />
      </RLink>
    );
  }

  const alpha2Country = detectAlpha2Country();
  const baseUrl = 'https://www.fanhome.com/';
  const href = alpha2Country
    ? `${baseUrl}${alpha2Country.toLowerCase()}`
    : baseUrl;

  return (
    <a href={href} className={classes.linkMui} style={{ cursor: 'pointer' }}>
      <Image className={classes.logo} name="logo" />
    </a>
  );
};

const AppBar = observer((props) => {
  const classes = useStyles();

  const { pageStore } = useStores();
  const { pages } = pageStore;
  const [open, setOpen] = useState(false);

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    pageStore.fetchPages();
  }, [pageStore]);

  return (
    <>
      <AppBarUI
        position="sticky"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}>
        <Toolbar className={classes.toolbar}>
          <Hidden mdUp>
            <div style={{ width: '56px', height: '56px' }}></div>
          </Hidden>
          <div id="cp-logo">
            <Logo />
          </div>
          <Hidden smDown>
            <div style={{ display: 'flex' }}>
              <ProfileButton />
            </div>
          </Hidden>
          <Hidden mdUp>
            <div style={{ disaply: 'flex' }}>
              <ProfileButton />
            </div>
          </Hidden>
        </Toolbar>
      </AppBarUI>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}>
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            <Image name="close" />
          </IconButton>
        </div>
        <Divider />
        <List>
          {pages.map((page) => (
            <ListItem button key={page.title}>
              <ListItemText primary={page.title} />
            </ListItem>
          ))}
        </List>
        <Divider />
      </Drawer>
    </>
  );
});

export default AppBar;
